import N8nPulse from './Pulse.vue';

export default N8nPulse;
